import { Controller } from '@hotwired/stimulus';

// Bouton qui ouvre une fenêtre de la page (outlet dialog : son sélecteur dans
// data-dialog-trigger-dialog-outlet).
export default class extends Controller {
    static outlets = ['dialog'];

    open() {
        if (this.hasDialogOutlet) this.dialogOutlet.open();
    }
}
